import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ProductEditor from './components/ProductEditor';
import ProductTable from './components/ProductTable';
import OfferGenerator from './components/OfferGenerator';
import OfferList from './components/OfferList';
import Navbar from './components/Navbar';
import PhotoGallery from './components/PhotoGallery';
import TemplateList from './components/TemplateList';
import TemplateEditor from './components/TemplateEditor';
import PriceEditor from './components/PriceEditor';
import CategoryManager from './components/CategoryManager';
import ArchivedProducts from './components/ArchivedProducts';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { token, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  
  return token ? <>{children}</> : <Navigate to="/login" />;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { token, loading } = useAuth();
  
  if (loading) {
    return <div className="loading">Loading...</div>;
  }
  
  return !token ? <>{children}</> : <Navigate to="/" />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } />
            <Route path="/" element={
              <ProtectedRoute>
                <Navbar />
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/product-editor/:id?" element={
              <ProtectedRoute>
                <Navbar />
                <ProductEditor />
              </ProtectedRoute>
            } />
            <Route path="/products-table" element={
              <ProtectedRoute>
                <Navbar />
                <ProductTable />
              </ProtectedRoute>
            } />
            <Route path="/offer-generator/:id?" element={
              <ProtectedRoute>
                <Navbar />
                <OfferGenerator />
              </ProtectedRoute>
            } />
            <Route path="/offers" element={
              <ProtectedRoute>
                <Navbar />
                <OfferList />
              </ProtectedRoute>
            } />
            {/* Add the gallery route */}
            <Route path="/gallery" element={
              <ProtectedRoute>
                <Navbar />
                <PhotoGallery />
              </ProtectedRoute>
            } />
            <Route
              path="/templates"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <TemplateList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/templates/new"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <TemplateEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/templates/:id"
              element={
                <ProtectedRoute>
                  <Navbar />
                  <TemplateEditor />
                </ProtectedRoute>
              }
            />
            <Route path="/price-editor" element={
              <ProtectedRoute>
                <PriceEditor />
              </ProtectedRoute>
            } />
            <Route path="/archive" element={
              <ProtectedRoute>
                <Navbar />
                <ArchivedProducts />
              </ProtectedRoute>
            } />
            <Route path="/category-manager" element={
              <ProtectedRoute>
                <Navbar />
                <CategoryManager />
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
